import React, { useEffect } from 'react';
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const FitBounds = ({ markers }) => {
  const map = useMap();
  useEffect(() => {
    const valid = markers.filter(m => m.lat && m.lng);
    if (valid.length > 0) {
      const bounds = valid.map(m => [m.lat, m.lng]);
      map.fitBounds(bounds, { padding: [50, 50], maxZoom: 10 });
    }
  }, [markers, map]);
  return null;
};

const SearchDemandMap = ({ searches }) => {
  const validSearches = (searches || []).filter(s => s.lat && s.lng);

  if (validSearches.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 20px', color: '#94a3b8', background: '#f8fafc', borderRadius: '12px' }}>
        No geocodable search data yet. Searches will appear on the map as people use your site.
      </div>
    );
  }

  const noResultCount = validSearches.filter(s => s.noResultSearches > 0 && !s.dealtWith).length;
  const coveredCount = validSearches.filter(s => s.noResultSearches === 0).length;

  return (
    <div data-testid="search-demand-map">
      <div className="admin-map-stats" style={{ marginBottom: '12px' }}>
        <div className="admin-map-stat">
          <span className="admin-map-dot" style={{ background: '#ef4444' }} />
          No engineers: {noResultCount}
        </div>
        <div className="admin-map-stat">
          <span className="admin-map-dot" style={{ background: '#22c55e' }} />
          Covered: {coveredCount}
        </div>
        <div className="admin-map-stat" style={{ marginLeft: 'auto', fontWeight: 600 }}>
          Total areas: {validSearches.length}
        </div>
      </div>

      <div style={{ borderRadius: '12px', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
        <MapContainer
          center={[54.0, -2.5]}
          zoom={6}
          style={{ height: '450px', width: '100%' }}
          scrollWheelZoom={true}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <FitBounds markers={validSearches} />

          {validSearches.map((s, idx) => {
            const hasNoResults = s.noResultSearches > 0 && !s.dealtWith;
            const color = hasNoResults ? '#ef4444' : '#22c55e';
            const radius = Math.min(8 + s.totalSearches * 3, 22);

            return (
              <CircleMarker
                key={idx}
                center={[s.lat, s.lng]}
                radius={radius}
                pathOptions={{
                  color: color,
                  fillColor: color,
                  fillOpacity: hasNoResults ? 0.7 : 0.4,
                  weight: 2
                }}
              >
                <Popup>
                  <div style={{ minWidth: '150px' }}>
                    <div style={{ fontWeight: 700, fontSize: '15px', marginBottom: '4px' }}>{s.postcode}</div>
                    <div style={{ fontSize: '13px', marginBottom: '3px' }}>
                      <strong>{s.totalSearches}</strong> search{s.totalSearches !== 1 ? 'es' : ''}
                    </div>
                    {s.noResultSearches > 0 && (
                      <div style={{ fontSize: '13px', color: '#dc2626', fontWeight: 600 }}>
                        {s.noResultSearches} with no engineers
                      </div>
                    )}
                    {s.noResultSearches === 0 && (
                      <div style={{ fontSize: '13px', color: '#22c55e', fontWeight: 600 }}>
                        Engineers available
                      </div>
                    )}
                    {s.dealtWith && (
                      <div style={{ fontSize: '11px', color: '#64748b', marginTop: '4px', fontStyle: 'italic' }}>
                        Dealt with
                      </div>
                    )}
                  </div>
                </Popup>
              </CircleMarker>
            );
          })}
        </MapContainer>
      </div>
    </div>
  );
};

export default SearchDemandMap;
